import {INVALID_SEARCH} from 'modules/search/actions/invalidSearch'
import {getHomeUrlWithUTMParams} from 'utils/utmParams'

import {MiddlewareType} from '../middlewareList'
import {REDIRECT_EXTERNAL} from './actions/externalRedirect'

const middleware: MiddlewareType = () => next => action => {
  switch (action.type) {
    case REDIRECT_EXTERNAL: {
      window.location.replace(action.url)
      break
    }

    case INVALID_SEARCH: {
      const href = getHomeUrlWithUTMParams()
      window.location.href = href
      break
    }

    default: {
      break
    }
  }

  return next(action)
}

export default middleware
